import axiosInstance from '../config/axios';

// Events
export const getEvents = (params = {}) =>
  axiosInstance.get('/get-events', { params }).then((res) => res.data);

export const getEventById = (eventId) =>
  axiosInstance.get(`/get-events/${eventId}`).then((res) => res.data);

export const addEvent = (data) =>
  axiosInstance.post('/add-events', data).then((res) => res.data);

export const editEvent = (eventId, data) =>
  axiosInstance.post(`/edit-events/${eventId}`, data).then((res) => res.data);

export const deleteEvent = (eventId) =>
  axiosInstance.delete(`/delete-event/${eventId}`).then((res) => res.data);

// Event Assignments
export const assignEvent = (data) =>
  axiosInstance.post('/assign-event', data).then((res) => res.data);

export const getEventAssignments = (params = {}) =>
  axiosInstance.get('/event-assignments', { params }).then((res) => res.data);

export const updateEventAssignment = (id, data) =>
  axiosInstance.put(`/event-assignments/${id}`, data).then((res) => res.data);

export const removeEventAssignment = (id) =>
  axiosInstance.delete(`/event-assignments/${id}`).then((res) => res.data);

export const checkEventAccess = (eventId) =>
  axiosInstance.get(`/check-event-access/${eventId}`).then((res) => res.data);

export const searchStudentsApi = (params = {}) =>
  axiosInstance.get('/search-student', { params }).then((res) => res.data);

// ──────────────────────────────────────────────
// Event Recordings APIs
// ──────────────────────────────────────────────
export const getEventRecordingsApi = (params = {}) =>
  axiosInstance.get('/community-recordings', { params }).then((res) => res.data);

export const addEventRecordingApi = (formData) =>
  axiosInstance.post('/add-community-recording', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => res.data);

export const deleteEventRecordingApi = (id) =>
  axiosInstance.delete(`/community-recording/${id}`).then((res) => res.data);

// ──────────────────────────────────────────────
// Event Workbook APIs
// ──────────────────────────────────────────────
export const createEventWorkBookApi = (formData) =>
  axiosInstance.post('/community-workbook/create', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => res.data);

export const getEventWorkbooksApi = (params = {}) =>
  axiosInstance.get(`/event-workbook/${params.eventId}`).then((res) => res.data);

export const deleteEventWorkBookApi = (id) =>
  axiosInstance.delete(`/community-workbook/${id}`).then((res) => res.data);

// ──────────────────────────────────────────────
// Event Homework APIs
// ──────────────────────────────────────────────
export const addEventHomeWorkApi = (formData) =>
  axiosInstance.post('/community-homework', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => res.data);

export const getEventHomeworkApi = (params = {}) =>
  axiosInstance.get('/community-homework', { params }).then((res) => res.data);

export const deleteEventHomeWorkApi = (id) =>
  axiosInstance.delete(`/community-homework/${id}`).then((res) => res.data);

export const addHomeWorkAnswerApi = (data) =>
  axiosInstance.post('/add-homework-answer', data).then((res) => res.data);

export const getHomeWorkAnswersApi = (homeworkId) =>
  axiosInstance.get(`/homework-answers/${homeworkId}`).then((res) => res.data);

// ──────────────────────────────────────────────
// Event Video APIs
// ──────────────────────────────────────────────
export const addEventVideoApi = (formData) =>
  axiosInstance.post('/add-community-video', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => res.data);

export const getEventVideosApi = (params = {}) =>
  axiosInstance.get('/list-community-videos', { params }).then((res) => res.data);

export const deleteEventVideoApi = (id) =>
  axiosInstance.delete(`/delete-community-video/${id}`).then((res) => res.data);

// ──────────────────────────────────────────────
// Event Quiz APIs
// ──────────────────────────────────────────────
export const createEventQuizApi = (data) =>
  axiosInstance.post('/create-community-quiz', data).then((res) => res.data);

export const getCommunityQuizApi = (quizId) =>
  axiosInstance.get(`/community-quiz/${quizId}`).then((res) => res.data);

export const submitCommunityQuizAnswerApi = (data) =>
  axiosInstance.post('/submit-community-quiz-answer', data).then((res) => res.data);

export const getEventQuizzesApi = (params = {}) =>
  axiosInstance.get('/list-community-quizzes', { params }).then((res) => res.data);

export const deleteEventQuizApi = (id) =>
  axiosInstance.delete(`/community-quiz/${id}`).then((res) => res.data);
